import { render, staticRenderFns } from "./Sims.vue?vue&type=template&id=114766e8&"
import script from "./Sims.vue?vue&type=script&lang=ts&"
export * from "./Sims.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('114766e8', component.options)
    } else {
      api.reload('114766e8', component.options)
    }
    module.hot.accept("./Sims.vue?vue&type=template&id=114766e8&", function () {
      api.rerender('114766e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaSim/Editar/Sims.vue"
export default component.exports